import React from 'react'
import { Box, Chip } from '@mui/material'

import AIIcon from '~assets/icons/AIIcon'
import { addOpacity, tagColors } from '~utils/colorUtils'

interface TagProps {
  tag: string
  size?: 'small' | 'medium'
  color?: string
  onDelete?: () => void
  calculated?: boolean
}

const Tag: React.FC<TagProps> = ({ tag, size = 'small', color, onDelete, calculated = false }) => {
  const randomColor = React.useMemo(
    () => tagColors[Math.floor(Math.random() * tagColors.length)],
    [],
  )
  const colorStart = color?.startsWith('#') ? color : `#${color}`
  const finalColor = colorStart || randomColor
  const fontSize = size === 'medium' ? '0.95rem' : '0.75rem'

  return (
    <Chip
      icon={
        calculated ? (
          <Box py={1} pl={1} className='flex-vh-align'>
            <AIIcon color={finalColor} />
          </Box>
        ) : undefined
      }
      label={tag}
      size={size}
      onDelete={onDelete}
      sx={{
        backgroundColor: addOpacity(finalColor, 0.15),
        color: finalColor,
        '& .MuiChip-label': {
          fontSize: fontSize,
        },
        '& .MuiChip-deleteIcon': {
          color: finalColor,
          '&:hover': {
            color: addOpacity(finalColor, 0.7),
          },
        },
      }}
    />
  )
}

export default Tag
